module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"account_hint":"Номер телефона. Пример: 380661234567"},"en":{"account_hint":"Phone number. Example: 380661234567"}}')
  delete Component.options._Ctor
}
